import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {
    AuthService,
    BaseSiteService,
    GlobalMessageService,
    GlobalMessageType,
    RoutingService,
    WindowRef
} from '@spartacus/core';
import {LoginFormComponentService} from '@spartacus/user/account/components';
import {AimoAuthRedirectService} from '../../../service/auth/aimo-auth-redirect.service';
import {openCloseSpinner} from '../../shared/utils/spinner/aimo-spinner-utils';
import {AimoBaseSite} from "../../../model/misc.model";
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class AimoLoginFormComponentService extends LoginFormComponentService {
    constructor(
        protected auth: AuthService,
        protected globalMessage: GlobalMessageService,
        protected winRef: WindowRef,
        protected routingService: RoutingService,
        protected authRedirectService: AimoAuthRedirectService,
        protected baseSiteService: BaseSiteService,
        @Inject(DOCUMENT) private document: Document,
        protected http: HttpClient,
    ) {
        super(auth, globalMessage, winRef);
        this.baseSiteService.get().subscribe((site: AimoBaseSite) => {
            if (site.loginUrl && false) {
                /*     const headers = new HttpHeaders({
                         'cache-control': 'private'
                     });
                     this.http.get(site.loginUrl, {headers, observe: "response"}).subscribe((response) => {
                         this.document.location.href = response.headers['location'];
                     });
                 */
                this.document.location.href = site.loginUrl;
            }
        })
    }

    protected onSuccess(isLoggedIn: boolean): void {
        if (isLoggedIn) {
            // We want to remove error messages on successful login (primary the bad username/password combination)
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
            // this.form.reset();
            this.authRedirectService.aimoRedirect();
            openCloseSpinner(this.document, false);
        }
        this.busy$.next(false);
    }
}
